import { createContext } from 'react'

const castrationContext = createContext()

export default castrationContext
